import { CONTACT_EMAIL, CONTACT_MAILTO } from "../contact.js";
import { openDialog } from "../dialog.js";
import { PRIVACY_DIALOG_ID } from "./PrivacyDialog.js";

/**
 * Legal links point at the real donor-web routes (`apps/donor-web/src/legal/paths.ts`,
 * `LEGAL_PATHS`) as full URLs at the product domain — this app is served from a separate
 * subdomain (www.givehere.co), so a relative `/privacy` would 404 here.
 */
export function Footer() {
  return (
    <footer className="footer">
      <div className="page footer__row">
        <a className="footer__brand" href="#top">
          <img src="/brand-mark.svg" alt="" width="26" height="26" />
          GiveHere
        </a>
        <p className="footer__tagline">Generosity, in the moment.</p>
        <div className="footer__meta">
          <span>© {new Date().getFullYear()} GiveHere</span>
          <a href="https://givehere.co/privacy">Privacy</a>
          <a href="https://givehere.co/terms">Terms</a>
          <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
          <button type="button" onClick={() => openDialog(PRIVACY_DIALOG_ID)}>
            Your information
          </button>
        </div>
      </div>
    </footer>
  );
}
